import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import List from '../List/index.js';

/**
 List Columns allow a single list of elements to be displayed in a series of columns.
 The number of columns is able to be responsively specified per breakpoint.
 This component uses the axl css 'columns' utility under the hood to achieve columns via CSS3
*/
import { jsx as _jsx } from "react/jsx-runtime";
function ListColumns(_ref) {
  let {
    xs,
    sm,
    md,
    lg,
    className,
    ...rest
  } = _ref;
  const rootClassName = clsx({
    columns: true,
    [`columns-${xs}`]: !!xs,
    [`columns-sm-${sm}`]: !!sm,
    [`columns-md-${md}`]: !!md,
    [`columns-lg-${lg}`]: !!lg
  }, className);
  return /*#__PURE__*/_jsx(List, {
    "data-cmp": "listColumns",
    className: rootClassName,
    ...rest
  });
}
export default ListColumns;